// WARNING: This file is auto-generated. Do not modify.
import React, { SVGProps } from 'react';
export const DeviceTabletSvgIcon = (
  props: SVGProps<SVGSVGElement>,
): React.ReactElement => (
  <svg width="1em" height="1em" viewBox="0 0 100 100" {...props}>
    <g fill="none" fillRule="evenodd">
      <rect
        width={55}
        height={77}
        x={22.5}
        y={11.5}
        stroke="#000"
        strokeWidth={3}
        rx={4}
      />
      <circle cx={50} cy={78} r={3} fill="#000" />
    </g>
  </svg>
);
